/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WarningTriangleIcon16Regular = forwardRef('WarningTriangleIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.875 10.656a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0Z" }),
        React.createElement("path", { d: "M8.75 4.688a.75.75 0 1 0-1.5 0V7.9a.75.75 0 1 0 1.5 0V4.688Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.864 1.232c.973-1.602 3.299-1.602 4.273 0l5.496 9.046C16.625 11.91 15.45 14 13.539 14H2.461C.551 14-.625 11.91.367 10.278l5.497-9.046Zm2.99.779a1 1 0 0 0-1.708 0l-5.497 9.046a.95.95 0 0 0 .812 1.443H13.54a.95.95 0 0 0 .812-1.443L8.855 2.01Z" })));
});
